import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HotelRecommendation, SuggestHotel } from '../models';
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../config/hotel-tours-list-page.config";

@Injectable()
export class ApiService {
  constructor(
    @Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig,
    private http: HttpClient,
  ) { }

  suggestHotels(query: string, countryId: number = null): Observable<SuggestHotel[]> {
    let params = new HttpParams().set('query', query);
    if (countryId) {
      params = params.set('countryId', countryId.toString());
    }

    return this.http.get<SuggestHotel[]>('/tours/hotel/suggestHotels', { params });
  }

  loadHotelPhoto(id: string | number): Observable<string[]> {
    const params = new HttpParams().set('hotelId', id.toString());

    return this.http.get('/new/hotel/hotel-photos', { params }).pipe(
      map((photos: string[]) => {
        return photos;
      }),
    );
  }

  getHotelRecommendation(hotelId: number): Observable<HotelRecommendation[]> {
    const params = new HttpParams().set('hotelId', hotelId.toString());
    return this.http.get<HotelRecommendation[]>('/tours/hotel/getHotelRecommendation', { params });
  }
}
